import React from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import isString from 'lodash/isString';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';

// CORE COMPONENTS
import CoreDownloadButton from 'core/form/control/types/upload/parts/DownloadButton'; // This is not an exposed component and is inideal

// STYLES
import styles from './downloadButton.module.scss';

// VARIABLES
const EXTENSIONS = [
  '.pdf',
  '.png',
  '.jpg',
  '.txt',
  '.csv',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx'
];

// FUNCTIONS
const hasExtension = fileName => EXTENSIONS.filter(extension => isString(fileName) && fileName.indexOf(extension) > 0).length < 1

// MAIN COMPONENT
const DownloadButton = ({
  children,
  className,
  data: { activity_log_history_id, is_sales }
}) => hasExtension(children) ? (
  children
) : (
  <CoreDownloadButton
    className={clsx(className, styles.button)}
    meta={{ fileName: children }}
    viewArgs={{
      endpoint: ENDPOINTS.uploads.inventory.activityLog, // This is really for both inventory and sales
      params: {
        activityLogHistoryId: activity_log_history_id,
        isSalesActivityRecord: is_sales ? 1 : 0
      }
    }}
  />
);

export default DownloadButton;
